document.addEventListener('DOMContentLoaded', () => {
	detailViewMore()
})

function detailViewMore() {
  // ページ読み込み時に.tab-content-0の存在をチェック
  const tabContent0 = document.querySelector('.tab-content-0');
  if (!tabContent0) return; // .tab-content-0が存在しない場合、処理を終了

  let baseHeight = 0; // 初期値設定
  const descriptionWrapperP = document.querySelector('.description-wrapper p'); // ('.description-wrapper p');
  const descriptionWrapper = document.querySelector('.description-wrapper'); // .description-wrapperへの参照を追加

  // baseHeightを更新し、条件に応じてクラスを追加/削除する関数
  const updateBaseHeight = () => {
    baseHeight = descriptionWrapperP.offsetHeight; // .description-wrapper pの高さを取得
    adjustHeightAndClass();
  };

  // 高さとクラスを調整する関数
  const adjustHeightAndClass = () => {
    if (baseHeight >= 65) {
      tabContent0.classList.add('over-height');
    } else {
      tabContent0.classList.remove('over-height');
    }
    if (tabContent0.querySelector('button').classList.contains('isOpen')) {
      descriptionWrapper.style.maxHeight = '1000px';
    } else {
      descriptionWrapper.style.maxHeight = '73px';
    }
  }

  // 初期の高さを設定し、リサイズイベントに対応
  updateBaseHeight();
  window.addEventListener('resize', function () {
    updateBaseHeight(); // リサイズ時も高さを更新
    if (tabContent0.querySelector('button').classList.contains('isOpen')) {
      // ボタンがクリックされた後のリサイズでは、高さを再設定
      descriptionWrapper.style.height = '100%';//`${baseHeight}px`;
    }
  });

  // buttonクリック時の動作を定義
  tabContent0.querySelector('button').addEventListener('click', function () {
    if(this.classList.contains('isOpen')) {
      // 閉じる時の処理
      this.classList.remove('isOpen')
      this.textContent = "READ MORE"
    } else {
      // 開く時の処理
      this.classList.add('isOpen')
      this.textContent = "CLOSE"
    }
    updateBaseHeight(); // クリック時に.baseHeightを更新し、適切に高さを設定
  });
}

